import { convertCurrency } from './converters'

export function calculateTotalProfit(bets, currencies, mainCurrency) {
  if (!currencies) {
    return 0
  }
  return Math.round(bets.filter(bet => bet.status !== 1).reduce((prev, cur) => {
    let netProfit = calculateBetReturn(cur.wager, cur.odds, cur.status) - cur.wager
    return convertCurrency(cur.currency, mainCurrency, netProfit, currencies) + prev
  }, 0))
}

export function calculateTotalBankroll(startingBankroll, bets, currencies, mainCurrency) {
  return startingBankroll + calculateTotalProfit(bets, currencies, mainCurrency) - calculateOpenBets(bets, currencies, mainCurrency).moneyInPlay
}

export function calculateOpenBets(bets, currencies, mainCurrency) {
  let openBets = bets.filter(bet => bet.status === 1)
  return {
    numBets: openBets.length,
    moneyInPlay: Math.round(openBets.reduce((prev, cur) => {
      return convertCurrency(cur.currency, mainCurrency, cur.wager, currencies) + prev
    }, 0))
  }
}


export function calculateBetReturn(wager, odds, status) {
  let betReturn = 0
  switch(status) {
    case 1:
    case 3:
      return 0
    case 2:
      betReturn = wager * odds
      break
    case 4:
      betReturn = wager
      break
    case 5:
      betReturn = (wager * (odds + 1)) / 2
      break
    case 6:
      betReturn = wager * 0.5
      break
    default:
      break
  }
  return Math.round(betReturn * 10) / 10
}

export function calculateBetEV(wager, edge) {
  return wager * edge
}

export function calculateAvgBetSize(bets, currencies, mainCurrency) {
  let totalSpent = 0
  if(!currencies) {
    return 0
  }
  bets.forEach(bet => totalSpent += convertCurrency(bet.currency, mainCurrency, bet.wager, currencies))
  return Math.floor(totalSpent / bets.length)
}

export function calculateAvgEv(bets, currencies, mainCurrency) {
  let totalEv = 0
  bets.forEach(bet => {
    if(!bet.edge) {

    }
    else {
    totalEv+=Math.round(calculateBetEV(convertCurrency(bet.currency, mainCurrency, bet.wager, currencies), bet.edge/100))
    }
  })
  return totalEv
}



/** WEBPACK FOOTER **
 ** ./src/utils/calculations.js
 **/